import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { isSmallKey } from '../functions/index.esm.js';
import styles from '../../styles/uitk-egds-layout-grid.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSLayoutGridItem = props => {
  const {
    alignSelf,
    area,
    children,
    className,
    colEnd,
    colSpan,
    colStart,
    dataTestId,
    justifySelf,
    rowSpan,
    rowStart,
    rowEnd,
    style
  } = props;
  const childrenArray = React.Children.toArray(children);
  if (!childrenArray.length) {
    return null;
  }
  const firstChild = childrenArray[0];
  const firstChildClassName = firstChild.props.className;
  const firstChildStyle = firstChild.props.style;
  const baseClass = 'uitk-layout-grid-item';
  const itemCustomPropValue = (suffix, value, isSpan) => {
    const isEnd = value === 'end';
    const isAll = value === 'all';
    let returnValue = {};
    if (isEnd) {
      returnValue = {
        [`--uitk-layoutgrid-${suffix}`]: `-1`
      };
    } else if (isAll) {
      returnValue = {
        [`--uitk-layoutgrid-${suffix}`]: `1`,
        [`--uitk-layoutgrid-${suffix.replace('start', 'end')}`]: `-1`
      };
    } else {
      returnValue = {
        [`--uitk-layoutgrid-${suffix}`]: isSpan ? `span ${value}` : `${value}`
      };
    }
    return returnValue;
  };
  const MakeCustomProp = (suffix, value, isSpan) => {
    const isObject = !Array.isArray(value) && typeof value === 'object';
    const obj = {};
    if (isObject) {
      Object.entries(value).map(([key, val]) => Object.assign(obj, itemCustomPropValue(`${suffix}${isSmallKey(key) ? '' : `-${key}`}`, val, isSpan)));
    } else {
      Object.assign(obj, itemCustomPropValue(suffix, value, isSpan));
    }
    return obj;
  };
  /**
   * Prevent invalid CSS Custom Properties from being applied
   *
   * @param value {UitkLayoutGridItemSpanValues | UitkLayoutConditionalGridSpan | UitkLayoutGridItemStartEndValues | UitkLayoutConditionalGridStartEnd}
   * @param suffix {string}
   * @param baseCSSClass {string}
   * @returns getClassNameList()
   */
  const conditionalGridItemClassName = (value, suffix, baseCSSClass = baseClass) => {
    const isObject = !Array.isArray(value) && typeof value === 'object';
    return getClassNameList(isObject ? Object.entries(value).map(([key]) => `${baseCSSClass}-has-${suffix}${isSmallKey(key) ? '' : `-by-${key}`}`) : `${baseCSSClass}-has-${suffix}`);
  };
  const wrapperClassNames = getClassNameList(baseClass, firstChildClassName, alignSelf && `${baseClass}-align-self-${alignSelf}`, area && `${baseClass}-has-column-start ${baseClass}-has-column-end ${baseClass}-has-row-start ${baseClass}-has-row-end`, colStart && conditionalGridItemClassName(colStart, 'column-start'), colEnd && conditionalGridItemClassName(colEnd, 'column-end'), colSpan && conditionalGridItemClassName(colSpan, 'column-start'), colSpan && colSpan === 'all' && conditionalGridItemClassName(colSpan, 'column-end'), rowStart && conditionalGridItemClassName(rowStart, 'row-start'), rowEnd && conditionalGridItemClassName(rowEnd, 'row-end'), rowSpan && conditionalGridItemClassName(rowSpan, 'row-start'), rowSpan && rowSpan === 'all' && conditionalGridItemClassName(rowSpan, 'row-end'), justifySelf && `${baseClass}-justify-self-${justifySelf}`, className);
  const gridItemCustomProps = {
    ...(area && {
      [`--uitk-layoutgrid-column-start`]: `${area}-start`,
      [`--uitk-layoutgrid-column-end`]: `${area}-end`,
      [`--uitk-layoutgrid-row-start`]: `${area}-start`,
      [`--uitk-layoutgrid-row-end`]: `${area}-end`
    }),
    ...(!area && {
      ...(colSpan && MakeCustomProp('column-start', colSpan, true)),
      ...(colStart && MakeCustomProp('column-start', colStart)),
      ...(colEnd && MakeCustomProp('column-end', colEnd)),
      ...(rowSpan && MakeCustomProp('row-start', rowSpan, true)),
      ...(rowStart && MakeCustomProp('row-start', rowStart)),
      ...(rowEnd && MakeCustomProp('row-end', rowEnd))
    }),
    ...(firstChildStyle && firstChildStyle),
    ...(style && style)
  };
  const decoratedChild = React.cloneElement(firstChild, {
    className: wrapperClassNames,
    style: gridItemCustomProps,
    ...(dataTestId && {
      'data-stid': dataTestId
    })
  });
  return decoratedChild;
};
EGDSLayoutGridItem.displayName = 'EGDSLayoutGridItem';
export { EGDSLayoutGridItem };